/* DewDropHues — Style You carousel: prev/next buttons + caption fit.
 *
 * Deliberately minimal. These buttons call scrollBy() on click -- they
 * never attach a scroll or wheel LISTENER, so there's no way for this to
 * fight the page's own vertical scroll the way an earlier prototype's
 * wheel-to-horizontal handler did elsewhere in this theme (see
 * dh-living-gallery.liquid's comment). The track itself already scrolls
 * natively via touch/trackpad/click-drag with no JS at all; this file
 * only adds the optional visible buttons for mouse users and keyboard/
 * screen-reader discoverability.
 *
 * Caption fit: the centered category label (component CSS) is set to
 * white-space: nowrap at a large size, per feedback that it should
 * never wrap to a second line. Pure CSS can't shrink text to fit a
 * box based on how long the STRING is -- font-size doesn't know
 * content length, only container width -- so a short shrink-to-fit
 * loop below measures each caption and scales it down only if it would
 * actually overflow at full size. Short captions ("Bath") stay at the
 * full CSS size; long ones ("Nested Pouch Set") shrink just enough to
 * stay on one line, down to a legibility floor.
 */
(function () {
  var CAPTION_MIN_PX = 14;

  function fitCaption(caption) {
    caption.style.fontSize = '';
    var available = caption.clientWidth;
    var needed = caption.scrollWidth;
    if (available <= 0 || needed <= available) return;
    var maxPx = parseFloat(getComputedStyle(caption).fontSize);
    // 0.98 safety margin -- guards against a caption that fits exactly
    // still triggering a scrollbar-width-style off-by-one wrap.
    var fitted = Math.floor(maxPx * (available / needed) * 0.98);
    caption.style.fontSize = Math.max(CAPTION_MIN_PX, fitted) + 'px';
  }

  function fitCaptions(root) {
    (root || document).querySelectorAll('.dh-style-you__slide-caption').forEach(fitCaption);
  }

  function setup(track) {
    var wrap = track.closest('.dh-style-you__track-wrap');
    if (!wrap) return;
    var prevBtn = wrap.querySelector('[data-dh-style-you-prev]');
    var nextBtn = wrap.querySelector('[data-dh-style-you-next]');
    if (!prevBtn || !nextBtn) return;

    function step() {
      var slide = track.querySelector('.dh-style-you__slide');
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
      var width = slide ? slide.getBoundingClientRect().width : track.clientWidth;
      return width + gap;
    }

    function updateDisabled() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateDisabled, { passive: true });
    window.addEventListener('resize', updateDisabled);
    updateDisabled();
  }

  function init() {
    document.querySelectorAll('.dh-style-you__track').forEach(setup);
    fitCaptions(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Independent of the per-track resize listener above (each of those
  // only knows about its own track/buttons) -- one global listener
  // re-fits every caption on the page when the viewport changes.
  window.addEventListener('resize', function () {
    fitCaptions(document);
  });

  // Theme editor: sections can be added/re-rendered without a full page
  // load, so re-run setup for a freshly injected section.
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.dh-style-you__track').forEach(setup);
    fitCaptions(event.target);
  });
})();
